import React from 'react';

import { milisecondsToTime } from './utils/milisecondsToTime';
interface TimerProps {
  timeToExpire: number;
  children: (props: {
    hours: string;
    minutes: string;
    seconds: string;
    miliseconds: number;
  }) => React.ReactNode;
}

export const LimitedTimerHoc: React.FC<TimerProps> = ({
  timeToExpire,
  children,
}) => {
  const [timer, setTimer] = React.useState({
    hours: '',
    minutes: '',
    seconds: '',
    miliseconds: 0,
  });

  React.useEffect(() => {
    const milliseconds = timeToExpire;
    const parsedTime = milisecondsToTime(milliseconds);

    setTimer(parsedTime);
  }, [timeToExpire]);

  React.useEffect(() => {
    const timeOut = setTimeout(() => {
      const nextSecondInMilliseconds = timer.miliseconds - 1000;
      const parsedTime = milisecondsToTime(nextSecondInMilliseconds);

      if (nextSecondInMilliseconds < 0) {
        clearTimeout(timeOut);
      } else {
        setTimer(parsedTime);
      }
    }, 1000);

    return () => {
      clearTimeout(timeOut);
    };
  }, [timer]);

  return <>{children(timer)}</>;
};
